module.exports = __webpack_public_path__ + "img/5@2x.ee877b9d.png";